module.exports = {"Phase":{"Basement":[],"Block":["Ground","1","2","3","4","5","6","7","8","Roof"]},"Site Wide":{"Other (specify below)":[]},"Completed Area (Estates)":{"Other (specify below)":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/swansLanding.json
// module id = 131
// module chunks = 0